import React, { useEffect, useState, useCallback } from 'react';
import { CheckCircle2, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';

const Toast = ({ message, type = 'info', onClose, duration = 4000 }) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = useCallback(() => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
    }, 250);
  }, [onClose]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [handleClose, duration]);

  const config = {
    success: {
      icon: <CheckCircle2 size={16} className="text-emerald-600 shrink-0" strokeWidth={2.2} />,
    },
    error: {
      icon: <AlertCircle size={16} className="text-rose-600 shrink-0" strokeWidth={2.2} />,
    },
    warning: {
      icon: <AlertTriangle size={16} className="text-amber-600 shrink-0" strokeWidth={2.2} />,
    },
    info: {
      icon: <Info size={16} className="text-blue-600 shrink-0" strokeWidth={2.2} />,
    }
  };

  const style = config[type] || config.info;

  return (
    <div
      className={`
        flex items-center gap-3 px-3.5 py-2.5 sm:px-4 sm:py-3 rounded-xl bg-white border border-zinc-200/90 shadow-xl shadow-zinc-950/10 pointer-events-auto transition-all duration-200 ease-out font-['Inter',sans-serif]
        ${isExiting ? 'opacity-0 translate-y-2 scale-95' : 'opacity-100 translate-y-0 scale-100 animate-slideIn'}
      `}
      role="alert"
    >
      {style.icon}
      <span className="text-xs font-medium text-zinc-900 tracking-tight leading-snug flex-1">
        {message}
      </span>
      <button
        type="button"
        onClick={handleClose}
        className="p-1 rounded-md text-zinc-400 hover:text-zinc-700 hover:bg-zinc-100 transition-colors shrink-0 -mr-1"
        aria-label="Close"
      >
        <X size={13} />
      </button>
    </div>
  );
};

export default Toast;
